import ApiClient from './client'
import * as utils from './utils'
import countries from './countries'
let baseURL;

let hashes = location.search.slice(location.search.indexOf('?') + 1).split('&');
let params = {};

hashes.map(hash => {
    let [key, val] = hash.split('=');
    params[key] = decodeURIComponent(val);
})

if(params.version){
    baseURL =`https://${params.version.replace('.', '')}.appspot.com`
}else if(params.subdomain){
    baseURL =`https://${params.subdomain.replace('.', '')}.nextinline.io`
}else{
    baseURL = window.location.host.includes('localhost') ? 'http://localhost:8080' : window.location.origin.replace('roots-staging', 'soil').replace('roots', 'soil').replace('medical', 'soil')
}

const apiClient = new ApiClient({
    baseURL,
})
window.otterApiClient = apiClient;

export {
    apiClient,
    utils,
    countries
};


// WEBPACK FOOTER //
// ./src/lib/index.js